import React from 'react';
import { RewardTiers, RewardsHubBanner, ProXtraFAQ, } from '../../components/RewardsHub';
import { PageSkeletonLoader } from '../../components/shared/page-layout';
import { RewardsAndOffersContext, RewardsHubProvider, InfoPerksContext, InfoRewardsContext, } from '../../contexts';
import '../../styles/ProgramDetailsTiers.scss';
import '../../styles/RewardsHub.scss';
export var RewardsHubContainer = function (_a) {
    var isMobile = _a.isMobile;
    var isLoading = (React.useContext(RewardsAndOffersContext) || {
        isLoading: false,
    }).isLoading;
    var _b = React.useContext(InfoRewardsContext), rewardsInfo = _b.rewardsInfo, isBlendedRewardsEnabled = _b.isBlendedRewardsEnabled;
    var perksInfo = React.useContext(InfoPerksContext).perksInfo;
    var infoData = isBlendedRewardsEnabled ? rewardsInfo : perksInfo;
    if (infoData) {
        sessionStorage.setItem('perkCounter', JSON.stringify(infoData === null || infoData === void 0 ? void 0 : infoData.perkCounter));
        sessionStorage.setItem('showPerksQualtricsSurvey', JSON.stringify(!(infoData === null || infoData === void 0 ? void 0 : infoData.recentlyAdded) && (infoData === null || infoData === void 0 ? void 0 : infoData.perkCounter) === 0));
    }
    return (React.createElement(RewardsHubProvider, { isMobile: isMobile },
        React.createElement("div", { className: "sui-relative" },
            React.createElement("div", { className: isMobile ? 'sui-px-4' : '' },
                React.createElement(PageSkeletonLoader, { isMobile: isMobile, isLoading: isLoading })),
            React.createElement("div", { style: {
                    visibility: isLoading ? 'hidden' : 'unset',
                } },
                React.createElement(RewardsHubBanner, { isMobile: isMobile }),
                React.createElement(RewardTiers, { isMobile: isMobile }),
                React.createElement(ProXtraFAQ, { isMobile: isMobile })))));
};
